import { getOccupiedTimes, formatDateForAPI } from './dateUtils';

// Validar datos de cita
export const validateAppointment = (appointment) => {
  const errors = [];
  
  if (!appointment.paciente?.trim()) {
    errors.push('El nombre del paciente es requerido');
  }
  
  if (!appointment.fecha) {
    errors.push('La fecha es requerida');
  }
  
  if (!appointment.hora) {
    errors.push('La hora es requerida');
  }
  
  if (!appointment.telefono?.trim()) {
    errors.push('El teléfono es requerido');
  }
  
  if (!appointment.motivo?.trim()) {
    errors.push('El motivo de la cita es requerido');
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

// Cargar horarios ocupados para una fecha
export const loadOccupiedTimes = async (fecha, apiUrl) => {
  try {
    console.log('🔍 Consultando citas para fecha:', fecha);
    const response = await fetch(`${apiUrl}/api/citas?fecha=${fecha}`);
    const data = await response.json();
    
    console.log('📅 Citas recibidas:', data);
    const citasFiltradas = data.filter(c => c.fecha === fecha);
    console.log('📅 Citas filtradas para fecha:', citasFiltradas);
    
    const horariosOcupados = citasFiltradas.map(c => c.hora);
    console.log('⏰ Horarios ocupados:', horariosOcupados);
    
    return horariosOcupados;
  } catch (error) {
    console.error('❌ Error al obtener citas:', error);
    return [];
  }
};

// Crear nueva cita
export const createAppointment = async (appointmentData, apiUrl) => {
  try {
    const response = await fetch(`${apiUrl}/api/citas`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(appointmentData)
    });
    
    if (!response.ok) {
      throw new Error('Error al crear la cita');
    }
    
    return await response.json();
  } catch (error) {
    console.error('❌ Error al crear cita:', error);
    throw error;
  }
};

// Actualizar cita existente
export const updateAppointment = async (appointmentId, appointmentData, apiUrl) => {
  try {
    const response = await fetch(`${apiUrl}/api/citas/${appointmentId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(appointmentData)
    });
    
    if (!response.ok) {
      throw new Error('Error al actualizar la cita');
    }
    
    return await response.json();
  } catch (error) {
    console.error('❌ Error al actualizar cita:', error);
    throw error;
  }
};

// Eliminar cita
export const deleteAppointment = async (appointmentId, apiUrl) => {
  try {
    const response = await fetch(`${apiUrl}/api/citas/${appointmentId}`, {
      method: 'DELETE'
    });
    
    if (!response.ok) {
      throw new Error('Error al eliminar la cita');
    }
    
    return true;
  } catch (error) {
    console.error('❌ Error al eliminar cita:', error);
    throw error;
  }
};

// Preparar datos de cita para envío
export const prepareAppointmentData = (appointment) => {
  return {
    paciente: appointment.paciente?.trim(),
    telefono: appointment.telefono?.trim(),
    rut: appointment.rut?.trim(),
    motivo: appointment.motivo?.trim(),
    fecha: formatDateForAPI(appointment.fecha),
    hora: appointment.hora,
    estado: appointment.estado || 'pendiente'
  };
};

// Verificar conflicto de horarios
export const checkTimeConflict = (appointment, existingAppointments, excludeId = null) => {
  const { fecha, hora, _id } = appointment;
  
  return existingAppointments.some(existing => 
    existing.fecha === fecha && 
    existing.hora === hora && 
    existing._id !== excludeId
  );
};

// Generar mensaje de WhatsApp para recordatorio
export const generateWhatsAppMessage = (appointment) => {
  const { paciente, fecha, hora, motivo } = appointment;
  
  return `
*Recordatorio de Cita:*
Hola ${paciente}, 

Te recordamos que tienes una cita programada con nosotros. 

*Fecha:* ${new Date(fecha).toLocaleDateString()}
*Hora:* ${hora}
*Motivo:* ${motivo}

Por favor, elige una de las siguientes opciones para confirmar o reagendar tu cita:

*1.* Confirmar Asistencia ✔️
*2.* Reagendar 
*3.* Cancelar ❌

Esperamos tu respuesta. ¡Gracias!
  `.trim();
};

// Formatear teléfono para WhatsApp
export const formatPhoneForWhatsApp = (phone) => {
  let telefonoLimpio = phone.replace(/[^0-9]/g, '');
  if (telefonoLimpio.startsWith('0')) {
    telefonoLimpio = '56' + telefonoLimpio.substring(1);
  }
  return telefonoLimpio;
}; 